import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/helpers/authHelper'
import { i18n } from '@/plugins/i18n'
import auth from '@/views/Auth/routes'
import companies from '@/views/Companies/routes'
import user from '@/views/User/routes'
import userManagement from '@/views/UserManagement/routes'
import affiliates from '@/views/Affiliates/routes'
import marketplace from '@/views/Marketplace/routes'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home',
    meta: {
      guest: true,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home/Pages/Home.vue'),
    meta: {
      layout: 'content',
      auth: true,
      title: i18n.t('Home'),
    },
  },
  ...auth,
  ...companies,
  ...user,
  ...userManagement,
  ...affiliates,
  ...marketplace,
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      auth: false,
      title: 'Error 404',
    },
  },
  {
    path: '*',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      auth: false,
      title: 'Error 404',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.guest)) {
    if (isLoggedIn()) {
      next({ name: 'home' })
    }
  }
  next()
})

router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME}`
  })
})

export default router
